import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  singleOrNullrknfaxokm1sl as singleOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  asSequence2phdjljfh9jhx as asSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_native16zxqjg6lrtlz as get_native } from '../NativeElement.commonHtml.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from './LinearLayouts.commonHtml.mjs';
import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import {
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
  Duration5ynfiptaqcrg as Duration,
  Duration__times_impl_sfuzvp17qfsy828s7xa as Duration__times_impl_sfuzvp,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { toNumber2e2hj9zugjwi2 as toNumber } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { json3n35pf5np6si4 as json } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance } from '../../models/ScreenTransitions.mjs';
import {
  isNumberiramasdbon0i as isNumber,
  isCharSequence1ju9jr1w86plq as isCharSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  numberToDouble210hrknaofnhf as numberToDouble,
  numberToInt1ygmcfwhs2fkq as numberToInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  removeSuffix3d61x5lsuvuho as removeSuffix,
  trim11nh7r46at6sx as trim,
  contains3ue2qo8xhmpf1 as contains,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  downTo39qhfeycepm1j as downTo,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  filter184huxd00uyfg as filter,
  toSet2morh2kqexfa2 as toSet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { removeAll3cm9rh0qak2y6 as removeAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { asSequence2lno4vpru4ldl as asSequence_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { CoordinatorFrame1xeiax3dpykfa as CoordinatorFrame } from './CoordinatorFrame.commonHtml.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from './Frame.commonHtml.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_showHideQueue() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return showHideQueue;
}
var showHideQueue;
function get_weightChangeQueue() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return weightChangeQueue;
}
var weightChangeQueue;
function set_workerScheduled(_set____db54di) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  workerScheduled = _set____db54di;
}
function get_workerScheduled() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return workerScheduled;
}
var workerScheduled;
function get_showHideAnimating() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return showHideAnimating;
}
var showHideAnimating;
function get_weightAnimating() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return weightAnimating;
}
var weightAnimating;
function get_log() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return log;
}
var log;
function get_combinedAnimationWorker() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return combinedAnimationWorker;
}
var combinedAnimationWorker;
var ShowHideRequestClass;
function ShowHideRequest() {
  if (ShowHideRequestClass === VOID) {
    class $ {
      constructor(goal, transition) {
        this.goal_1 = goal;
        this.transition_1 = transition;
      }
      toString() {
        return 'ShowHideRequest(goal=' + this.goal_1 + ', transition=' + this.transition_1.toString() + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.goal_1);
        result = imul(result, 31) + this.transition_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ShowHideRequest()))
          return false;
        if (!(this.goal_1 === other.goal_1))
          return false;
        if (!this.transition_1.equals(other.transition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ShowHideRequest');
    ShowHideRequestClass = $;
  }
  return ShowHideRequestClass;
}
function OngoingAnimation$play$lambda(it) {
  var tmp0_safe_receiver = singleOrNull(it.get_children_4cwbp4_k$());
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_debugName_58dolx_k$();
  return tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
}
function OngoingAnimation$done$lambda$lambda(it) {
  var tmp0_safe_receiver = singleOrNull(it.get_children_4cwbp4_k$());
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_debugName_58dolx_k$();
  return tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
}
var OngoingAnimationClass;
function OngoingAnimation() {
  if (OngoingAnimationClass === VOID) {
    class $ {
      constructor(on, from, to, goal, startRatio, easingCss) {
        easingCss = easingCss === VOID ? 'linear' : easingCss;
        this.on_1 = on;
        this.from_1 = from;
        this.to_1 = to;
        this.goal_1 = goal;
        this.startRatio_1 = startRatio;
        this.easingCss_1 = easingCss;
        this.totalTime_1 = 1000.0;
        var tmp = this;
        var tmp_0 = get_native(this.on_1).element_1;
        tmp.myElement_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
        var tmp_1 = this;
        var tmp_2 = get_native(this.on_1.get_children_4cwbp4_k$().get_c1px32_k$(0)).element_1;
        tmp_1.child_1 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
        this.animation_1 = null;
        this.widthChildResume_1 = '';
        this.maxWidthChildResume_1 = '';
        this.heightChildResume_1 = '';
        this.maxHeightChildResume_1 = '';
        this.job_1 = Job(get_job(this.on_1.get_coroutineContext_115oqo_k$()));
        this.job_1.invokeOnCompletion_n6cffu_k$((it) => {
          get_showHideAnimating().remove_gppy8k_k$(this.on_1);
          return Unit_instance;
        });
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp1_safe_receiver = singleOrNull(this.on_1.get_children_4cwbp4_k$());
          tmp0_safe_receiver.info_59mt0k_k$(['QueuedAnimation: ' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_debugName_58dolx_k$()) + ' / ' + this.goal_1 + ': ' + JSON.stringify(this.from_1) + ' -> ' + JSON.stringify(this.to_1)]);
        }
        this.closed_1 = false;
        var tmp_3 = this;
        tmp_3.done_1 = () => {
          var tmp;
          if (this.closed_1) {
            return Unit_instance;
          }
          this.closed_1 = true;
          this.job_1.cancel$default_8haxne_k$();
          var tmp0_safe_receiver = get_log();
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp_0 = get_showHideAnimating().get_keys_wop4xp_k$();
            tmp0_safe_receiver.log_iyb52q_k$(['showHideAnimating: ' + joinToString(tmp_0, VOID, VOID, VOID, VOID, VOID, OngoingAnimation$done$lambda$lambda)]);
          }
          this.myElement_1.hidden = !this.goal_1;
          var tmp_1 = this.on_1.get_parent_hy4reb_k$();
          var tmp1_safe_receiver = tmp_1 instanceof RowOrCol() ? tmp_1 : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
          }
          this.myElement_1.classList.remove('animatingShowHide');
          this.child_1.style.width = '100%';
          this.child_1.style.removeProperty('maxWidth');
          this.child_1.style.height = '100%';
          this.child_1.style.removeProperty('maxHeight');
          return Unit_instance;
        };
      }
      animRatio_i9cq62_k$() {
        return ensureNotNull(this.animation_1).currentTime / this.totalTime_1;
      }
      play_lpqhd0_k$() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp1_safe_receiver = singleOrNull(this.on_1.get_children_4cwbp4_k$());
          tmp0_safe_receiver.info_59mt0k_k$(['Starting animation on ' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_debugName_58dolx_k$())]);
        }
        this.myElement_1.hidden = false;
        this.totalTime_1 = toNumber(_Duration___get_inWholeMilliseconds__impl__msfiry(get_theme(this.on_1).transitionDuration_1));
        var tmp = this;
        var tmp_0 = get_native(this.on_1).element_1;
        var tmp0 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2 = [this.from_1, this.to_1];
        // Inline function 'com.lightningkite.kiteui.views.direct.animate' call
        var options = json([to('duration', this.totalTime_1), to('easing', this.easingCss_1)]);
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = tmp0.animate(tmp2, options);
        // Inline function 'kotlin.also' call
        var this_0 = (!(tmp_1 == null) ? !(tmp_1 == null) : false) ? tmp_1 : THROW_CCE();
        // Inline function 'kotlin.also' call
        var this_1 = this.startRatio_1 * this.totalTime_1;
        var tmp0_safe_receiver_0 = get_log();
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.info_59mt0k_k$(['Starting at ' + this_1]);
        }
        this_0.currentTime = this_1;
        this_0.onfinish = (it) => {
          this.done_1();
          return Unit_instance;
        };
        this_0.oncancel = (it) => {
          this.done_1();
          return Unit_instance;
        };
        this_0.onremove = (it) => {
          this.done_1();
          return Unit_instance;
        };
        tmp.animation_1 = this_0;
        this.myElement_1.classList.add('animatingShowHide');
        var tmp0_0 = get_showHideAnimating();
        // Inline function 'kotlin.collections.set' call
        var key = this.on_1;
        tmp0_0.put_4fpzoq_k$(key, this);
        var tmp2_safe_receiver = get_log();
        if (tmp2_safe_receiver == null)
          null;
        else {
          var tmp_2 = get_showHideAnimating().get_keys_wop4xp_k$();
          tmp2_safe_receiver.log_iyb52q_k$(['showHideAnimating: ' + joinToString(tmp_2, VOID, VOID, VOID, VOID, VOID, OngoingAnimation$play$lambda)]);
        }
      }
      cancel_2l89ey_k$() {
        ensureNotNull(this.animation_1).finish();
        this.done_1();
      }
      pretendEnd_mdjd5r_k$() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.info_59mt0k_k$(['pretendEnd']);
        }
        ensureNotNull(this.animation_1).pause();
        this.myElement_1.hidden = !this.goal_1;
        this.widthChildResume_1 = this.child_1.style.width;
        this.maxWidthChildResume_1 = this.child_1.style.maxWidth;
        this.heightChildResume_1 = this.child_1.style.height;
        this.maxHeightChildResume_1 = this.child_1.style.maxHeight;
        this.child_1.style.width = '100%';
        this.child_1.style.removeProperty('maxWidth');
        this.child_1.style.height = '100%';
        this.child_1.style.removeProperty('maxHeight');
      }
      continueNow_moitpb_k$() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.info_59mt0k_k$(['continueNow']);
        }
        this.myElement_1.hidden = false;
        this.child_1.style.width = this.widthChildResume_1;
        this.child_1.style.maxWidth = this.maxWidthChildResume_1;
        this.child_1.style.height = this.heightChildResume_1;
        this.child_1.style.maxHeight = this.maxHeightChildResume_1;
        ensureNotNull(this.animation_1).play();
      }
      toString() {
        return 'OngoingAnimation(on=' + this.on_1.toString() + ', from=' + toString(this.from_1) + ', to=' + toString(this.to_1) + ', goal=' + this.goal_1 + ', startRatio=' + this.startRatio_1 + ', easingCss=' + this.easingCss_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.on_1);
        result = imul(result, 31) + hashCode(this.from_1) | 0;
        result = imul(result, 31) + hashCode(this.to_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.goal_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.startRatio_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.easingCss_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OngoingAnimation()))
          return false;
        if (!equals(this.on_1, other.on_1))
          return false;
        if (!equals(this.from_1, other.from_1))
          return false;
        if (!equals(this.to_1, other.to_1))
          return false;
        if (!(this.goal_1 === other.goal_1))
          return false;
        if (!equals(this.startRatio_1, other.startRatio_1))
          return false;
        if (!(this.easingCss_1 === other.easingCss_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OngoingAnimation');
    OngoingAnimationClass = $;
  }
  return OngoingAnimationClass;
}
function buildKeyframes($this) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [json([to('flexGrow', '' + $this.fromWeight_1), to('flexShrink', '' + $this.fromWeight_1), to('flexBasis', $this.fromBasis_1)]), json([to('flexGrow', '' + $this.toWeight_1), to('flexShrink', '' + $this.toWeight_1), to('flexBasis', $this.toBasis_1)])];
}
var OngoingWeightAnimationClass;
function OngoingWeightAnimation() {
  if (OngoingWeightAnimationClass === VOID) {
    class $ {
      constructor(on, fromWeight, toWeight, fromBasis, toBasis, startRatio) {
        this.on_1 = on;
        this.fromWeight_1 = fromWeight;
        this.toWeight_1 = toWeight;
        this.fromBasis_1 = fromBasis;
        this.toBasis_1 = toBasis;
        this.startRatio_1 = startRatio;
        this.totalTime_1 = 1000.0;
        var tmp = this;
        var tmp_0 = get_native(this.on_1).element_1;
        tmp.myElement_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
        var tmp_1 = this;
        var tmp_2 = get_native(this.on_1.get_children_4cwbp4_k$().get_c1px32_k$(0)).element_1;
        tmp_1.child_1 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
        this.animation_1 = null;
        this.widthChildResume_1 = '';
        this.maxWidthChildResume_1 = '';
        this.heightChildResume_1 = '';
        this.maxHeightChildResume_1 = '';
        this.savedFlexGrow_1 = '';
        this.savedFlexShrink_1 = '';
        this.savedFlexBasis_1 = '';
        this.savedProgress_1 = this.startRatio_1 * 1000.0;
        this.job_1 = Job(get_job(this.on_1.get_coroutineContext_115oqo_k$()));
        var tmp_3 = CoroutineScope(this.job_1);
        onRemove(tmp_3, () => {
          get_weightAnimating().remove_gppy8k_k$(this.on_1);
          return Unit_instance;
        });
        this.closed_1 = false;
        var tmp_4 = this;
        tmp_4.done_1 = () => {
          var tmp;
          if (this.closed_1) {
            return Unit_instance;
          }
          this.closed_1 = true;
          this.job_1.cancel$default_8haxne_k$();
          this.myElement_1.classList.remove('animatingShowHide');
          this.myElement_1.style.flexGrow = '' + this.toWeight_1;
          this.myElement_1.style.flexShrink = '' + this.toWeight_1;
          this.myElement_1.style.flexBasis = !(this.toWeight_1 === 0.0) ? '0' : 'auto';
          var tmp_0 = this.on_1.get_parent_hy4reb_k$();
          var tmp0_safe_receiver = tmp_0 instanceof RowOrCol() ? tmp_0 : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
          }
          this.child_1.style.width = '100%';
          this.child_1.style.removeProperty('maxWidth');
          this.child_1.style.height = '100%';
          this.child_1.style.removeProperty('maxHeight');
          return Unit_instance;
        };
      }
      animRatio_i9cq62_k$() {
        return ensureNotNull(this.animation_1).currentTime / this.totalTime_1;
      }
      play_lpqhd0_k$() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp1_safe_receiver = singleOrNull(this.on_1.get_children_4cwbp4_k$());
          tmp0_safe_receiver.info_59mt0k_k$(['Starting weight animation on ' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_debugName_58dolx_k$()) + ': ' + this.fromWeight_1 + '(' + this.fromBasis_1 + ') -> ' + this.toWeight_1 + '(' + this.toBasis_1 + ')']);
        }
        this.totalTime_1 = toNumber(_Duration___get_inWholeMilliseconds__impl__msfiry(get_theme(this.on_1).transitionDuration_1));
        var tmp = this;
        var tmp0 = this.myElement_1;
        var tmp2 = buildKeyframes(this);
        // Inline function 'com.lightningkite.kiteui.views.direct.animate' call
        var options = json([to('duration', this.totalTime_1), to('easing', 'linear')]);
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0.animate(tmp2, options);
        // Inline function 'kotlin.also' call
        var this_0 = (!(tmp_0 == null) ? !(tmp_0 == null) : false) ? tmp_0 : THROW_CCE();
        // Inline function 'kotlin.also' call
        var this_1 = this.startRatio_1 * this.totalTime_1;
        var tmp0_safe_receiver_0 = get_log();
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.info_59mt0k_k$(['Weight anim starting at ' + this_1]);
        }
        this_0.currentTime = this_1;
        this_0.onfinish = (it) => {
          this.done_1();
          return Unit_instance;
        };
        this_0.oncancel = (it) => {
          this.done_1();
          return Unit_instance;
        };
        this_0.onremove = (it) => {
          this.done_1();
          return Unit_instance;
        };
        tmp.animation_1 = this_0;
        this.myElement_1.classList.add('animatingShowHide');
        var tmp0_0 = get_weightAnimating();
        // Inline function 'kotlin.collections.set' call
        var key = this.on_1;
        tmp0_0.put_4fpzoq_k$(key, this);
      }
      cancel_2l89ey_k$() {
        var tmp0_safe_receiver = this.animation_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cancel();
        }
        this.closed_1 = true;
        this.job_1.cancel$default_8haxne_k$();
        this.myElement_1.classList.remove('animatingShowHide');
        this.child_1.style.width = '100%';
        this.child_1.style.removeProperty('maxWidth');
        this.child_1.style.height = '100%';
        this.child_1.style.removeProperty('maxHeight');
      }
      pretendEnd_mdjd5r_k$() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.info_59mt0k_k$(['weight pretendEnd']);
        }
        var tmp = this;
        var tmp1_safe_receiver = this.animation_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.currentTime;
        tmp.savedProgress_1 = tmp2_elvis_lhs == null ? this.startRatio_1 * this.totalTime_1 : tmp2_elvis_lhs;
        var tmp3_safe_receiver = this.animation_1;
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.cancel();
        }
        this.savedFlexGrow_1 = this.myElement_1.style.flexGrow;
        this.savedFlexShrink_1 = this.myElement_1.style.flexShrink;
        this.savedFlexBasis_1 = this.myElement_1.style.flexBasis;
        this.myElement_1.style.flexGrow = '' + this.toWeight_1;
        this.myElement_1.style.flexShrink = '' + this.toWeight_1;
        this.myElement_1.style.flexBasis = !(this.toWeight_1 === 0.0) ? '0' : 'auto';
        this.widthChildResume_1 = this.child_1.style.width;
        this.maxWidthChildResume_1 = this.child_1.style.maxWidth;
        this.heightChildResume_1 = this.child_1.style.height;
        this.maxHeightChildResume_1 = this.child_1.style.maxHeight;
        this.child_1.style.width = '100%';
        this.child_1.style.removeProperty('maxWidth');
        this.child_1.style.height = '100%';
        this.child_1.style.removeProperty('maxHeight');
      }
      continueNow_moitpb_k$() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.info_59mt0k_k$(['weight continueNow']);
        }
        this.myElement_1.style.flexGrow = this.savedFlexGrow_1;
        this.myElement_1.style.flexShrink = this.savedFlexShrink_1;
        this.myElement_1.style.flexBasis = this.savedFlexBasis_1;
        this.child_1.style.width = this.widthChildResume_1;
        this.child_1.style.maxWidth = this.maxWidthChildResume_1;
        this.child_1.style.height = this.heightChildResume_1;
        this.child_1.style.maxHeight = this.maxHeightChildResume_1;
        this.totalTime_1 = toNumber(_Duration___get_inWholeMilliseconds__impl__msfiry(get_theme(this.on_1).transitionDuration_1));
        var tmp = this;
        var tmp0 = this.myElement_1;
        var tmp2 = buildKeyframes(this);
        // Inline function 'com.lightningkite.kiteui.views.direct.animate' call
        var options = json([to('duration', this.totalTime_1), to('easing', 'linear')]);
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0.animate(tmp2, options);
        // Inline function 'kotlin.also' call
        var this_0 = (!(tmp_0 == null) ? !(tmp_0 == null) : false) ? tmp_0 : THROW_CCE();
        this_0.currentTime = this.savedProgress_1;
        this_0.onfinish = (it) => {
          this.done_1();
          return Unit_instance;
        };
        this_0.oncancel = (it) => {
          this.done_1();
          return Unit_instance;
        };
        this_0.onremove = (it) => {
          this.done_1();
          return Unit_instance;
        };
        tmp.animation_1 = this_0;
      }
    }
    initMetadataForClass($, 'OngoingWeightAnimation');
    OngoingWeightAnimationClass = $;
  }
  return OngoingWeightAnimationClass;
}
function nativeAnimateShow(_this__u8e3s4, transition) {
  transition = transition === VOID ? Companion_getInstance().None_1 : transition;
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  var tmp0_safe_receiver = get_log();
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_safe_receiver = singleOrNull(_this__u8e3s4.get_children_4cwbp4_k$());
    tmp0_safe_receiver.info_59mt0k_k$(['' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_debugName_58dolx_k$()) + '.nativeAnimateShow']);
  }
  var tmp0 = get_showHideQueue();
  // Inline function 'kotlin.collections.set' call
  var value = new (ShowHideRequest())(true, transition);
  tmp0.put_4fpzoq_k$(_this__u8e3s4, value);
  ensureWorkerScheduled();
}
function nativeAnimateHide(_this__u8e3s4, transition) {
  transition = transition === VOID ? Companion_getInstance().None_1 : transition;
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  var tmp0_safe_receiver = get_log();
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_safe_receiver = singleOrNull(_this__u8e3s4.get_children_4cwbp4_k$());
    tmp0_safe_receiver.info_59mt0k_k$(['' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_debugName_58dolx_k$()) + '.nativeAnimateHide']);
  }
  var tmp0 = get_showHideQueue();
  // Inline function 'kotlin.collections.set' call
  var value = new (ShowHideRequest())(false, transition);
  tmp0.put_4fpzoq_k$(_this__u8e3s4, value);
  ensureWorkerScheduled();
}
function ensureWorkerScheduled() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  if (!get_workerScheduled()) {
    set_workerScheduled(true);
    window.setTimeout(get_combinedAnimationWorker(), 32);
  }
}
function nativeSetupPullToRefresh(_this__u8e3s4, refreshAction) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  var state = new (PullToRefreshState())();
  var PULL_THRESHOLD = 60.0;
  var MAX_PULL = 120.0;
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = get_native(_this__u8e3s4);
  var tmp0_safe_receiver = this_0.element_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var scrollElement = tmp0_safe_receiver;
    if (!(scrollElement instanceof HTMLElement))
      THROW_CCE();
    var tmp_0 = document.createElement('div');
    var indicator = tmp_0 instanceof HTMLDivElement ? tmp_0 : THROW_CCE();
    indicator.className = 'ptr-indicator';
    indicator.style.position = 'fixed';
    indicator.style.transition = 'height 0.2s ease, opacity 0.2s ease';
    indicator.style.opacity = '0';
    var tmp_1 = document.createElement('div');
    var circle = tmp_1 instanceof HTMLDivElement ? tmp_1 : THROW_CCE();
    circle.className = 'ptr-icon-circle';
    var tmp_2 = document.createElement('div');
    var arrow = tmp_2 instanceof HTMLDivElement ? tmp_2 : THROW_CCE();
    arrow.className = 'ptr-arrow';
    arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/><\/svg>';
    var tmp_3 = document.createElement('div');
    var spinner = tmp_3 instanceof HTMLDivElement ? tmp_3 : THROW_CCE();
    spinner.className = 'ptr-spinner';
    spinner.style.display = 'none';
    circle.appendChild(arrow);
    circle.appendChild(spinner);
    indicator.appendChild(circle);
    ensureNotNull(document.body).appendChild(indicator);
    state.indicator_1 = indicator;
    state.circle_1 = circle;
    state.arrow_1 = arrow;
    state.spinner_1 = spinner;
    scrollElement.addEventListener('touchstart', (event) => {
      var tmp;
      if (state.isRefreshing_1) {
        return Unit_instance;
      }
      // Inline function 'kotlin.js.asDynamic' call
      var touch = event.touches[0];
      var tmp_0 = state;
      var tmp_1 = touch.clientY;
      tmp_0.startY_1 = numberToDouble(isNumber(tmp_1) ? tmp_1 : THROW_CCE());
      return Unit_instance;
    }, {passive: true});
    scrollElement.addEventListener('touchmove', (event) => {
      var tmp;
      if (state.isRefreshing_1) {
        return Unit_instance;
      }
      var tmp_0;
      if (scrollElement.scrollTop > 0) {
        if (state.isPulling_1) {
          state.resetIndicator_45kj0w_k$();
        }
        return Unit_instance;
      }
      // Inline function 'kotlin.js.asDynamic' call
      var touch = event.touches[0];
      var tmp_1 = touch.clientY;
      var currentY = numberToDouble(isNumber(tmp_1) ? tmp_1 : THROW_CCE());
      var deltaY = currentY - state.startY_1;
      var tmp_2;
      if (deltaY > 0) {
        state.isPulling_1 = true;
        event.preventDefault();
        // Inline function 'kotlin.math.sqrt' call
        var x = deltaY * MAX_PULL;
        var tmp0 = Math.sqrt(x);
        // Inline function 'kotlin.math.min' call
        var b = MAX_PULL;
        var pullDistance = Math.min(tmp0, b);
        state.updatePosition_p14c6k_k$(scrollElement);
        indicator.style.transition = 'none';
        indicator.style.height = '' + pullDistance + 'px';
        indicator.style.opacity = '1';
        // Inline function 'kotlin.math.min' call
        var a = pullDistance / PULL_THRESHOLD;
        var rotation = Math.min(a, 1.0) * 180.0;
        circle.style.transform = 'rotate(' + rotation + 'deg)';
        tmp_2 = Unit_instance;
      } else if (state.isPulling_1) {
        state.resetIndicator_45kj0w_k$();
        tmp_2 = Unit_instance;
      }
      return Unit_instance;
    }, {passive: false});
    var touchEndHandler = (_unused_var__etf5q3) => {
      var tmp;
      if (state.isPulling_1 && !state.isRefreshing_1) {
        var tmp0_elvis_lhs = toDoubleOrNull(removeSuffix(indicator.style.height, 'px'));
        var indicatorHeight = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        if (indicatorHeight >= PULL_THRESHOLD) {
          state.isRefreshing_1 = true;
          arrow.style.display = 'none';
          spinner.style.display = '';
          indicator.style.transition = 'height 0.2s ease';
          indicator.style.height = '' + PULL_THRESHOLD + 'px';
          refreshAction.startAction_u0zgbm_k$(_this__u8e3s4);
          var tmp_0 = window;
          tmp_0.setTimeout(() => {
            var tmp;
            if (state.isRefreshing_1) {
              state.resetIndicator_45kj0w_k$();
              tmp = Unit_instance;
            }
            return Unit_instance;
          }, 500);
        } else {
          state.resetIndicator_45kj0w_k$();
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
    scrollElement.addEventListener('touchend', touchEndHandler);
    scrollElement.addEventListener('touchcancel', touchEndHandler);
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.elementToDo_1.add_utx5q5_k$((it) => {
      var scrollElement = it;
      if (!(scrollElement instanceof HTMLElement))
        THROW_CCE();
      var tmp = document.createElement('div');
      var indicator = tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
      indicator.className = 'ptr-indicator';
      indicator.style.position = 'fixed';
      indicator.style.transition = 'height 0.2s ease, opacity 0.2s ease';
      indicator.style.opacity = '0';
      var tmp_0 = document.createElement('div');
      var circle = tmp_0 instanceof HTMLDivElement ? tmp_0 : THROW_CCE();
      circle.className = 'ptr-icon-circle';
      var tmp_1 = document.createElement('div');
      var arrow = tmp_1 instanceof HTMLDivElement ? tmp_1 : THROW_CCE();
      arrow.className = 'ptr-arrow';
      arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/><\/svg>';
      var tmp_2 = document.createElement('div');
      var spinner = tmp_2 instanceof HTMLDivElement ? tmp_2 : THROW_CCE();
      spinner.className = 'ptr-spinner';
      spinner.style.display = 'none';
      circle.appendChild(arrow);
      circle.appendChild(spinner);
      indicator.appendChild(circle);
      ensureNotNull(document.body).appendChild(indicator);
      state.indicator_1 = indicator;
      state.circle_1 = circle;
      state.arrow_1 = arrow;
      state.spinner_1 = spinner;
      scrollElement.addEventListener('touchstart', (event) => {
        var tmp;
        if (state.isRefreshing_1) {
          return Unit_instance;
        }
        // Inline function 'kotlin.js.asDynamic' call
        var touch = event.touches[0];
        var tmp_0 = state;
        var tmp_1 = touch.clientY;
        tmp_0.startY_1 = numberToDouble(isNumber(tmp_1) ? tmp_1 : THROW_CCE());
        return Unit_instance;
      }, {passive: true});
      scrollElement.addEventListener('touchmove', (event) => {
        var tmp;
        if (state.isRefreshing_1) {
          return Unit_instance;
        }
        var tmp_0;
        if (scrollElement.scrollTop > 0) {
          if (state.isPulling_1) {
            state.resetIndicator_45kj0w_k$();
          }
          return Unit_instance;
        }
        // Inline function 'kotlin.js.asDynamic' call
        var touch = event.touches[0];
        var tmp_1 = touch.clientY;
        var currentY = numberToDouble(isNumber(tmp_1) ? tmp_1 : THROW_CCE());
        var deltaY = currentY - state.startY_1;
        var tmp_2;
        if (deltaY > 0) {
          state.isPulling_1 = true;
          event.preventDefault();
          // Inline function 'kotlin.math.sqrt' call
          var x = deltaY * MAX_PULL;
          var tmp0 = Math.sqrt(x);
          // Inline function 'kotlin.math.min' call
          var b = MAX_PULL;
          var pullDistance = Math.min(tmp0, b);
          state.updatePosition_p14c6k_k$(scrollElement);
          indicator.style.transition = 'none';
          indicator.style.height = '' + pullDistance + 'px';
          indicator.style.opacity = '1';
          // Inline function 'kotlin.math.min' call
          var a = pullDistance / PULL_THRESHOLD;
          var rotation = Math.min(a, 1.0) * 180.0;
          circle.style.transform = 'rotate(' + rotation + 'deg)';
          tmp_2 = Unit_instance;
        } else if (state.isPulling_1) {
          state.resetIndicator_45kj0w_k$();
          tmp_2 = Unit_instance;
        }
        return Unit_instance;
      }, {passive: false});
      var touchEndHandler = (_unused_var__etf5q3) => {
        var tmp;
        if (state.isPulling_1 && !state.isRefreshing_1) {
          var tmp0_elvis_lhs = toDoubleOrNull(removeSuffix(indicator.style.height, 'px'));
          var indicatorHeight = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
          if (indicatorHeight >= PULL_THRESHOLD) {
            state.isRefreshing_1 = true;
            arrow.style.display = 'none';
            spinner.style.display = '';
            indicator.style.transition = 'height 0.2s ease';
            indicator.style.height = '' + PULL_THRESHOLD + 'px';
            refreshAction.startAction_u0zgbm_k$(_this__u8e3s4);
            var tmp_0 = window;
            tmp_0.setTimeout(() => {
              var tmp;
              if (state.isRefreshing_1) {
                state.resetIndicator_45kj0w_k$();
                tmp = Unit_instance;
              }
              return Unit_instance;
            }, 500);
          } else {
            state.resetIndicator_45kj0w_k$();
          }
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
      scrollElement.addEventListener('touchend', touchEndHandler);
      scrollElement.addEventListener('touchcancel', touchEndHandler);
      return Unit_instance;
    });
  }
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_0 = $this$reactive.state_a9mnra_k$(refreshAction);
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
    var tmp;
    if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      tmp = true;
    } else {
      if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
        tmp = true;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
          tmp = false;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
            tmp = false;
          } else {
            _ReactiveState___get_raw__impl__92ipya(this_0);
            tmp = false;
          }
        }
      }
    }
    var loading = tmp;
    var tmp_0;
    if (!loading && state.isRefreshing_1) {
      state.resetIndicator_45kj0w_k$();
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  });
}
var PullToRefreshStateClass;
function PullToRefreshState() {
  if (PullToRefreshStateClass === VOID) {
    class $ {
      constructor() {
        this.startY_1 = 0.0;
        this.isPulling_1 = false;
        this.isRefreshing_1 = false;
        this.indicator_1 = null;
        this.circle_1 = null;
        this.arrow_1 = null;
        this.spinner_1 = null;
      }
      resetIndicator_45kj0w_k$() {
        var tmp0_elvis_lhs = this.indicator_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var ind = tmp;
        ind.style.transition = 'height 0.2s ease, opacity 0.2s ease';
        ind.style.height = '0px';
        ind.style.opacity = '0';
        var tmp1_safe_receiver = this.circle_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.transform = 'rotate(0deg)';
        }
        var tmp3_safe_receiver = this.arrow_1;
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.display = '';
        }
        var tmp5_safe_receiver = this.spinner_1;
        var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
        if (tmp6_safe_receiver == null)
          null;
        else {
          tmp6_safe_receiver.display = 'none';
        }
        this.isPulling_1 = false;
        this.isRefreshing_1 = false;
      }
      updatePosition_p14c6k_k$(scrollElement) {
        var tmp0_elvis_lhs = this.indicator_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var ind = tmp;
        var rect = scrollElement.getBoundingClientRect();
        ind.style.top = '' + rect.top + 'px';
        ind.style.left = '' + rect.left + 'px';
        ind.style.width = '' + rect.width + 'px';
        var computed = window.getComputedStyle(scrollElement);
        ind.style.color = computed.color;
        // Inline function 'kotlin.text.trim' call
        var this_0 = computed.getPropertyValue('--nearest-background-color');
        var bg = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(bg) > 0) {
          var tmp1_safe_receiver = this.circle_1;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.background = bg;
          }
        }
      }
    }
    initMetadataForClass($, 'PullToRefreshState', PullToRefreshState);
    PullToRefreshStateClass = $;
  }
  return PullToRefreshStateClass;
}
function combinedAnimationWorker$lambda() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!get_showHideQueue().isEmpty_y1axqb_k$()) {
    tmp = HashMap().new_kotlin_collections_HashMap_gc38m_k$(get_showHideQueue());
  } else {
    tmp = null;
  }
  var currentShowHideQueue = tmp;
  get_showHideQueue().clear_j9egeb_k$();
  var tmp_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!get_weightChangeQueue().isEmpty_y1axqb_k$()) {
    tmp_0 = HashMap().new_kotlin_collections_HashMap_gc38m_k$(get_weightChangeQueue());
  } else {
    tmp_0 = null;
  }
  var currentWeightQueue = tmp_0;
  get_weightChangeQueue().clear_j9egeb_k$();
  set_workerScheduled(false);
  if (currentShowHideQueue == null && currentWeightQueue == null)
    return Unit_instance;
  var delayLevel = null;
  var tmp_1 = get_AppScope();
  launch(tmp_1, VOID, VOID, combinedAnimationWorker$lambda$slambda(currentShowHideQueue, currentWeightQueue, delayLevel));
  return Unit_instance;
}
function combinedAnimationWorker$lambda$slambda$lambda(it) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return it.get_parent_hy4reb_k$() == null || it.get_children_4cwbp4_k$().isEmpty_y1axqb_k$() || get_native(it).get_children_4cwbp4_k$().isEmpty_y1axqb_k$() || get_native(it).element_1 == null;
}
function combinedAnimationWorker$lambda$slambda$lambda_0(it) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return it.get_parent_hy4reb_k$() == null || it.get_children_4cwbp4_k$().isEmpty_y1axqb_k$() || get_native(it).get_children_4cwbp4_k$().isEmpty_y1axqb_k$() || get_native(it).element_1 == null;
}
function combinedAnimationWorker$lambda$slambda$lambda_1(it) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  var tmp = get_native(it.get_key_18j28a_k$()).element_1;
  return !(tmp instanceof HTMLElement ? tmp : THROW_CCE()).hidden;
}
function combinedAnimationWorker$lambda$slambda$lambda_2(_destruct__k2r9zo) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  // Inline function 'kotlin.collections.component1' call
  var on = _destruct__k2r9zo.get_key_18j28a_k$();
  var tmp0_safe_receiver = on.get_parent_hy4reb_k$();
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_native(tmp0_safe_receiver);
  var tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.element_1;
  var tmp2_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var parentEl = tmp_0;
  if (!parentEl.classList.contains('optimized'))
    return null;
  var tmp_1 = get_native(on).element_1;
  var myElement = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
  var tmp_2 = asSequence(downTo(parentEl.children.length - 1 | 0, 0));
  // Inline function 'kotlin.sequences.find' call
  var tmp0 = mapNotNull(tmp_2, (it) => {
    // Inline function 'org.w3c.dom.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = parentEl.children[it];
    return tmp instanceof HTMLElement ? tmp : null;
  });
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.sequences.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (!element.hidden) {
        tmp$ret$4 = element;
        break $l$block;
      }
    }
    tmp$ret$4 = null;
  }
  var lastVisible = tmp$ret$4;
  return equals(lastVisible, myElement) ? on : null;
}
function invoke$toCssTransform(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var parts = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  if (!(_this__u8e3s4.translationX_1 === 0.0) || !(_this__u8e3s4.translationY_1 === 0.0)) {
    parts.add_utx5q5_k$('translate(' + numberToInt(_this__u8e3s4.translationX_1 * 100) + '%, ' + numberToInt(_this__u8e3s4.translationY_1 * 100) + '%)');
  }
  if (!(_this__u8e3s4.scaleX_1 === 1.0) || !(_this__u8e3s4.scaleY_1 === 1.0)) {
    parts.add_utx5q5_k$('scale(' + _this__u8e3s4.scaleX_1 + ', ' + _this__u8e3s4.scaleY_1 + ')');
  }
  if (!(_this__u8e3s4.rotation_1 === 0.0)) {
    parts.add_utx5q5_k$('rotate(' + _this__u8e3s4.rotation_1 + 'deg)');
  }
  if (!(_this__u8e3s4.rotationX_1 === 0.0)) {
    parts.add_utx5q5_k$('rotateX(' + _this__u8e3s4.rotationX_1 + 'deg)');
  }
  if (!(_this__u8e3s4.rotationY_1 === 0.0)) {
    parts.add_utx5q5_k$('rotateY(' + _this__u8e3s4.rotationY_1 + 'deg)');
  }
  return parts.isEmpty_y1axqb_k$() ? null : joinToString(parts, ' ');
}
function combinedAnimationWorker$lambda$slambda($currentShowHideQueue, $currentWeightQueue, $delayLevel) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = get_log();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.info_59mt0k_k$(['//////////////////////////////////////////']);
    }
    var tmp;
    if (!($currentShowHideQueue == null)) {
      var tmp1_safe_receiver = get_log();
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.info_59mt0k_k$(['Show/Hide Queued: ' + $currentShowHideQueue.get_size_woubt6_k$()]);
      }
      // Inline function 'kotlin.collections.map' call
      var this_0 = get_showHideAnimating().get_entries_p20ztl_k$();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var item = _iterator__ex2g4s.next_20eer_k$();
        var tmp$ret$2 = to(item.get_key_18j28a_k$(), item.get_value_j01efc_k$());
        destination.add_utx5q5_k$(tmp$ret$2);
      }
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s_0.next_20eer_k$();
        var tmp_0;
        if ($currentShowHideQueue.get_keys_wop4xp_k$().contains_aljjnj_k$(element.first_1)) {
          var tmp0_safe_receiver_0 = get_log();
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            var tmp1_safe_receiver_0 = singleOrNull(element.first_1.get_children_4cwbp4_k$());
            tmp0_safe_receiver_0.info_59mt0k_k$(['Cancelling show/hide animation on ' + (tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.get_debugName_58dolx_k$())]);
          }
          var r = to(element.first_1, element.second_1.animRatio_i9cq62_k$());
          element.second_1.cancel_2l89ey_k$();
          tmp_0 = r;
        } else {
          tmp_0 = null;
        }
        var tmp0_safe_receiver_1 = tmp_0;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_0.add_utx5q5_k$(tmp0_safe_receiver_1);
        }
      }
      // Inline function 'kotlin.collections.associate' call
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
      var _iterator__ex2g4s_1 = destination_0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
        // Inline function 'kotlin.collections.plusAssign' call
        destination_1.put_4fpzoq_k$(element_0.first_1, element_0.second_1);
      }
      tmp = destination_1;
    } else {
      tmp = emptyMap();
    }
    var pastShowHideRatios = tmp;
    var tmp_1;
    if (!($currentWeightQueue == null)) {
      var tmp2_safe_receiver = get_log();
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.info_59mt0k_k$(['Weight Queued: ' + $currentWeightQueue.get_size_woubt6_k$()]);
      }
      // Inline function 'kotlin.collections.map' call
      var this_1 = get_weightAnimating().get_entries_p20ztl_k$();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s_2 = this_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
        var item_0 = _iterator__ex2g4s_2.next_20eer_k$();
        var tmp$ret$16 = to(item_0.get_key_18j28a_k$(), item_0.get_value_j01efc_k$());
        destination_2.add_utx5q5_k$(tmp$ret$16);
      }
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_3 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_3 = destination_2.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
        var element_1 = _iterator__ex2g4s_3.next_20eer_k$();
        var tmp_2;
        if ($currentWeightQueue.get_keys_wop4xp_k$().contains_aljjnj_k$(element_1.first_1)) {
          var tmp0_safe_receiver_2 = get_log();
          if (tmp0_safe_receiver_2 == null)
            null;
          else {
            var tmp1_safe_receiver_1 = singleOrNull(element_1.first_1.get_children_4cwbp4_k$());
            tmp0_safe_receiver_2.info_59mt0k_k$(['Cancelling weight animation on ' + (tmp1_safe_receiver_1 == null ? null : tmp1_safe_receiver_1.get_debugName_58dolx_k$())]);
          }
          var r_0 = to(element_1.first_1, element_1.second_1.animRatio_i9cq62_k$());
          element_1.second_1.cancel_2l89ey_k$();
          tmp_2 = r_0;
        } else {
          tmp_2 = null;
        }
        var tmp0_safe_receiver_3 = tmp_2;
        if (tmp0_safe_receiver_3 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_3.add_utx5q5_k$(tmp0_safe_receiver_3);
        }
      }
      // Inline function 'kotlin.collections.associate' call
      var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_3, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_4 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_0);
      var _iterator__ex2g4s_4 = destination_3.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
        var element_2 = _iterator__ex2g4s_4.next_20eer_k$();
        // Inline function 'kotlin.collections.plusAssign' call
        destination_4.put_4fpzoq_k$(element_2.first_1, element_2.second_1);
      }
      tmp_1 = destination_4;
    } else {
      tmp_1 = emptyMap();
    }
    var pastWeightRatios = tmp_1;
    var tmp3_safe_receiver = $currentShowHideQueue;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.get_keys_wop4xp_k$();
    if (tmp4_safe_receiver == null)
      null;
    else {
      removeAll(tmp4_safe_receiver, combinedAnimationWorker$lambda$slambda$lambda);
    }
    var tmp5_safe_receiver = $currentWeightQueue;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.get_keys_wop4xp_k$();
    if (tmp6_safe_receiver == null)
      null;
    else {
      removeAll(tmp6_safe_receiver, combinedAnimationWorker$lambda$slambda$lambda_0);
    }
    var tmp7_safe_receiver = $currentShowHideQueue;
    if (tmp7_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_5 = tmp7_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
        var element_3 = _iterator__ex2g4s_5.next_20eer_k$();
        var tmp0_safe_receiver_4 = get_log();
        if (tmp0_safe_receiver_4 == null)
          null;
        else {
          var tmp1_safe_receiver_2 = singleOrNull(element_3.get_key_18j28a_k$().get_children_4cwbp4_k$());
          tmp0_safe_receiver_4.info_59mt0k_k$(['  ShowHide: ' + (tmp1_safe_receiver_2 == null ? null : tmp1_safe_receiver_2.get_debugName_58dolx_k$()) + ' -> ' + element_3.get_value_j01efc_k$().goal_1]);
        }
      }
    }
    var tmp8_safe_receiver = $currentWeightQueue;
    if (tmp8_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_6 = tmp8_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_6.hasNext_bitz1p_k$()) {
        var element_4 = _iterator__ex2g4s_6.next_20eer_k$();
        var tmp0_safe_receiver_5 = get_log();
        if (tmp0_safe_receiver_5 == null)
          null;
        else {
          var tmp1_safe_receiver_3 = singleOrNull(element_4.get_key_18j28a_k$().get_children_4cwbp4_k$());
          tmp0_safe_receiver_5.info_59mt0k_k$(['  Weight: ' + (tmp1_safe_receiver_3 == null ? null : tmp1_safe_receiver_3.get_debugName_58dolx_k$()) + ' -> ' + element_4.get_value_j01efc_k$().toString()]);
        }
      }
    }
    var tmp9_safe_receiver = $currentWeightQueue;
    var tmp_3;
    if (tmp9_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_5 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_7 = tmp9_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_7.hasNext_bitz1p_k$()) {
        var element_5 = _iterator__ex2g4s_7.next_20eer_k$();
        var tmp$ret$39;
        $l$block_0: {
          // Inline function 'kotlin.collections.component1' call
          var on = element_5.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var weights = element_5.get_value_j01efc_k$();
          if (!(weights.first_1 === 0.0)) {
            tmp$ret$39 = null;
            break $l$block_0;
          }
          var tmp_4 = get_native(on).element_1;
          var myElement = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
          var tmp0_safe_receiver_6 = on.get_parent_hy4reb_k$();
          var tmp1_safe_receiver_4 = tmp0_safe_receiver_6 == null ? null : get_native(tmp0_safe_receiver_6);
          var tmp_5 = tmp1_safe_receiver_4 == null ? null : tmp1_safe_receiver_4.element_1;
          var tmp2_elvis_lhs = tmp_5 instanceof HTMLElement ? tmp_5 : null;
          var tmp_6;
          if (tmp2_elvis_lhs == null) {
            tmp$ret$39 = null;
            break $l$block_0;
          } else {
            tmp_6 = tmp2_elvis_lhs;
          }
          var parentEl = tmp_6;
          var parentStyle = window.getComputedStyle(parentEl);
          var isColumn = contains(parentStyle.flexDirection, 'column');
          var rect = myElement.getBoundingClientRect();
          tmp$ret$39 = to(on, '' + (isColumn ? rect.height : rect.width) + 'px');
        }
        var tmp0_safe_receiver_7 = tmp$ret$39;
        if (tmp0_safe_receiver_7 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_5.add_utx5q5_k$(tmp0_safe_receiver_7);
        }
      }
      tmp_3 = destination_5;
    }
    var tmp10_safe_receiver = tmp_3;
    var tmp_7;
    if (tmp10_safe_receiver == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.collections.associate' call
      var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp10_safe_receiver, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_6 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_1);
      var _iterator__ex2g4s_8 = tmp10_safe_receiver.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_8.hasNext_bitz1p_k$()) {
        var element_6 = _iterator__ex2g4s_8.next_20eer_k$();
        // Inline function 'kotlin.collections.plusAssign' call
        destination_6.put_4fpzoq_k$(element_6.first_1, element_6.second_1);
      }
      tmp_7 = destination_6;
    }
    var tmp11_elvis_lhs = tmp_7;
    var weightFromBasis = tmp11_elvis_lhs == null ? emptyMap() : tmp11_elvis_lhs;
    var tmp12_safe_receiver = get_log();
    if (tmp12_safe_receiver == null)
      null;
    else {
      tmp12_safe_receiver.info_59mt0k_k$(['// Lock current sizes for disappearing/shrinking views.']);
    }
    var tmp13_safe_receiver = $currentShowHideQueue;
    if (tmp13_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_9 = tmp13_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_9.hasNext_bitz1p_k$()) {
        var element_7 = _iterator__ex2g4s_9.next_20eer_k$();
        $l$block_1: {
          // Inline function 'kotlin.collections.component1' call
          var on_0 = element_7.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var request = element_7.get_value_j01efc_k$();
          if (request.goal_1) {
            break $l$block_1;
          }
          var tmp_8 = get_native(on_0).element_1;
          var myElement_0 = tmp_8 instanceof HTMLElement ? tmp_8 : THROW_CCE();
          var tmp_9 = get_native(on_0.get_children_4cwbp4_k$().get_c1px32_k$(0)).element_1;
          var child = tmp_9 instanceof HTMLElement ? tmp_9 : THROW_CCE();
          child.style.width = myElement_0.clientWidth.toString() + 'px';
          child.style.maxWidth = 'unset';
          child.style.height = myElement_0.clientHeight.toString() + 'px';
          child.style.maxHeight = 'unset';
        }
      }
    }
    var tmp14_safe_receiver = $currentWeightQueue;
    if (tmp14_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_10 = tmp14_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_10.hasNext_bitz1p_k$()) {
        var element_8 = _iterator__ex2g4s_10.next_20eer_k$();
        $l$block_2: {
          // Inline function 'kotlin.collections.component1' call
          var on_1 = element_8.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var weights_0 = element_8.get_value_j01efc_k$();
          var fromWeight = weights_0.component1_7eebsc_k$();
          var toWeight = weights_0.component2_7eebsb_k$();
          if (toWeight >= fromWeight) {
            break $l$block_2;
          }
          var tmp_10 = get_native(on_1).element_1;
          var myElement_1 = tmp_10 instanceof HTMLElement ? tmp_10 : THROW_CCE();
          var tmp_11 = get_native(on_1.get_children_4cwbp4_k$().get_c1px32_k$(0)).element_1;
          var child_0 = tmp_11 instanceof HTMLElement ? tmp_11 : THROW_CCE();
          child_0.style.width = myElement_1.clientWidth.toString() + 'px';
          child_0.style.maxWidth = 'unset';
          child_0.style.height = myElement_1.clientHeight.toString() + 'px';
          child_0.style.maxHeight = 'unset';
        }
      }
    }
    var tmp15_safe_receiver = $currentShowHideQueue;
    var tmp16_safe_receiver = tmp15_safe_receiver == null ? null : asSequence_0(tmp15_safe_receiver);
    var tmp_12;
    if (tmp16_safe_receiver == null) {
      tmp_12 = null;
    } else {
      tmp_12 = filter(tmp16_safe_receiver, combinedAnimationWorker$lambda$slambda$lambda_1);
    }
    var tmp17_safe_receiver = tmp_12;
    var tmp_13;
    if (tmp17_safe_receiver == null) {
      tmp_13 = null;
    } else {
      // Inline function 'kotlin.sequences.associate' call
      // Inline function 'kotlin.sequences.associateTo' call
      var destination_7 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
      var _iterator__ex2g4s_11 = tmp17_safe_receiver.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_11.hasNext_bitz1p_k$()) {
        var element_9 = _iterator__ex2g4s_11.next_20eer_k$();
        var tmp_14 = element_9.get_key_18j28a_k$();
        var tmp_15 = window;
        var tmp_16 = get_native(element_9.get_key_18j28a_k$()).element_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(tmp_14, tmp_15.getComputedStyle(tmp_16 instanceof HTMLElement ? tmp_16 : THROW_CCE()).display);
        destination_7.put_4fpzoq_k$(pair.first_1, pair.second_1);
      }
      tmp_13 = destination_7;
    }
    var tmp18_elvis_lhs = tmp_13;
    var displayValuesPreHide = tmp18_elvis_lhs == null ? emptyMap() : tmp18_elvis_lhs;
    var tmp19_safe_receiver = $delayLevel;
    var tmp_17 = tmp19_safe_receiver;
    if ((tmp_17 == null ? null : new (Duration())(tmp_17)) == null)
      null;
    else {
      var tmp_18 = tmp19_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_18 == null ? null : new (Duration())(tmp_18)).rawValue_1;
      yield* delay(it, $completion);
    }
    var tmp20_safe_receiver = get_log();
    if (tmp20_safe_receiver == null)
      null;
    else {
      tmp20_safe_receiver.info_59mt0k_k$(['// Get the whole layout into the goal state for measurement.']);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_12 = get_showHideAnimating().get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s_12.hasNext_bitz1p_k$()) {
      var element_10 = _iterator__ex2g4s_12.next_20eer_k$();
      element_10.get_value_j01efc_k$().pretendEnd_mdjd5r_k$();
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_13 = get_weightAnimating().get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s_13.hasNext_bitz1p_k$()) {
      var element_11 = _iterator__ex2g4s_13.next_20eer_k$();
      element_11.get_value_j01efc_k$().pretendEnd_mdjd5r_k$();
    }
    var tmp21_safe_receiver = $currentShowHideQueue;
    var tmp_19;
    if (tmp21_safe_receiver == null) {
      tmp_19 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_8 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(tmp21_safe_receiver.get_size_woubt6_k$());
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_14 = tmp21_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_14.hasNext_bitz1p_k$()) {
        var item_1 = _iterator__ex2g4s_14.next_20eer_k$();
        var tmp_20 = get_native(item_1.get_key_18j28a_k$()).element_1;
        var was = (tmp_20 instanceof HTMLElement ? tmp_20 : THROW_CCE()).hidden;
        var tmp_21 = get_native(item_1.get_key_18j28a_k$()).element_1;
        (tmp_21 instanceof HTMLElement ? tmp_21 : THROW_CCE()).hidden = !item_1.get_value_j01efc_k$().goal_1;
        var tmp_22 = item_1.get_key_18j28a_k$().get_parent_hy4reb_k$();
        var tmp0_safe_receiver_8 = tmp_22 instanceof RowOrCol() ? tmp_22 : null;
        if (tmp0_safe_receiver_8 == null)
          null;
        else {
          tmp0_safe_receiver_8.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
        }
        var tmp1_safe_receiver_5 = get_log();
        if (tmp1_safe_receiver_5 == null)
          null;
        else {
          var tmp2_safe_receiver_0 = singleOrNull(item_1.get_key_18j28a_k$().get_children_4cwbp4_k$());
          tmp1_safe_receiver_5.info_59mt0k_k$(['View ' + (tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.get_debugName_58dolx_k$()) + ' -> ' + item_1.get_value_j01efc_k$().goal_1]);
        }
        var tmp$ret$73 = to(item_1.get_key_18j28a_k$(), was);
        destination_8.add_utx5q5_k$(tmp$ret$73);
      }
      tmp_19 = destination_8;
    }
    var beforeVisibility = tmp_19;
    var tmp22_safe_receiver = $currentShowHideQueue;
    var tmp23_safe_receiver = tmp22_safe_receiver == null ? null : asSequence_0(tmp22_safe_receiver);
    var tmp_23;
    if (tmp23_safe_receiver == null) {
      tmp_23 = null;
    } else {
      tmp_23 = mapNotNull(tmp23_safe_receiver, combinedAnimationWorker$lambda$slambda$lambda_2);
    }
    var tmp24_safe_receiver = tmp_23;
    var tmp25_elvis_lhs = tmp24_safe_receiver == null ? null : toSet(tmp24_safe_receiver);
    var isLastVisibleAfterHide = tmp25_elvis_lhs == null ? emptySet() : tmp25_elvis_lhs;
    var tmp26_safe_receiver = get_log();
    if (tmp26_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_9 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(isLastVisibleAfterHide, 10));
      var _iterator__ex2g4s_15 = isLastVisibleAfterHide.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_15.hasNext_bitz1p_k$()) {
        var item_2 = _iterator__ex2g4s_15.next_20eer_k$();
        var tmp0_safe_receiver_9 = singleOrNull(item_2.get_children_4cwbp4_k$());
        var tmp1_elvis_lhs = tmp0_safe_receiver_9 == null ? null : tmp0_safe_receiver_9.get_debugName_58dolx_k$();
        var tmp$ret$76 = tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
        destination_9.add_utx5q5_k$(tmp$ret$76);
      }
      tmp26_safe_receiver.log_iyb52q_k$(['isLastVisibleAfterHide: ' + toString(destination_9)]);
    }
    var tmp27_safe_receiver = $currentWeightQueue;
    var tmp_24;
    if (tmp27_safe_receiver == null) {
      tmp_24 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_10 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(tmp27_safe_receiver.get_size_woubt6_k$());
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_16 = tmp27_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_16.hasNext_bitz1p_k$()) {
        var item_3 = _iterator__ex2g4s_16.next_20eer_k$();
        // Inline function 'kotlin.collections.component1' call
        var on_2 = item_3.get_key_18j28a_k$();
        // Inline function 'kotlin.collections.component2' call
        var weights_1 = item_3.get_value_j01efc_k$();
        var toWeight_0 = weights_1.component2_7eebsb_k$();
        var tmp_25 = get_native(on_2).element_1;
        var myElement_2 = tmp_25 instanceof HTMLElement ? tmp_25 : THROW_CCE();
        var savedGrow = myElement_2.style.flexGrow;
        var savedShrink = myElement_2.style.flexShrink;
        var savedBasis = myElement_2.style.flexBasis;
        myElement_2.style.flexGrow = '' + toWeight_0;
        myElement_2.style.flexShrink = '' + toWeight_0;
        myElement_2.style.flexBasis = !(toWeight_0 === 0.0) ? '0' : 'auto';
        var tmp_26 = on_2.get_parent_hy4reb_k$();
        var tmp0_safe_receiver_10 = tmp_26 instanceof RowOrCol() ? tmp_26 : null;
        if (tmp0_safe_receiver_10 == null)
          null;
        else {
          tmp0_safe_receiver_10.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
        }
        var tmp$ret$80 = to(on_2, new (Triple())(savedGrow, savedShrink, savedBasis));
        destination_10.add_utx5q5_k$(tmp$ret$80);
      }
      tmp_24 = destination_10;
    }
    var beforeWeightStyles = tmp_24;
    var tmp28_safe_receiver = $currentWeightQueue;
    var tmp_27;
    if (tmp28_safe_receiver == null) {
      tmp_27 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_11 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_17 = tmp28_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_17.hasNext_bitz1p_k$()) {
        var element_12 = _iterator__ex2g4s_17.next_20eer_k$();
        var tmp$ret$88;
        $l$block_4: {
          // Inline function 'kotlin.collections.component1' call
          var on_3 = element_12.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var weights_2 = element_12.get_value_j01efc_k$();
          if (!(weights_2.second_1 === 0.0)) {
            tmp$ret$88 = null;
            break $l$block_4;
          }
          var tmp_28 = get_native(on_3).element_1;
          var myElement_3 = tmp_28 instanceof HTMLElement ? tmp_28 : THROW_CCE();
          var tmp0_safe_receiver_11 = on_3.get_parent_hy4reb_k$();
          var tmp1_safe_receiver_6 = tmp0_safe_receiver_11 == null ? null : get_native(tmp0_safe_receiver_11);
          var tmp_29 = tmp1_safe_receiver_6 == null ? null : tmp1_safe_receiver_6.element_1;
          var tmp2_elvis_lhs_0 = tmp_29 instanceof HTMLElement ? tmp_29 : null;
          var tmp_30;
          if (tmp2_elvis_lhs_0 == null) {
            tmp$ret$88 = null;
            break $l$block_4;
          } else {
            tmp_30 = tmp2_elvis_lhs_0;
          }
          var parentEl_0 = tmp_30;
          var parentStyle_0 = window.getComputedStyle(parentEl_0);
          var isColumn_0 = contains(parentStyle_0.flexDirection, 'column');
          var rect_0 = myElement_3.getBoundingClientRect();
          tmp$ret$88 = to(on_3, '' + (isColumn_0 ? rect_0.height : rect_0.width) + 'px');
        }
        var tmp0_safe_receiver_12 = tmp$ret$88;
        if (tmp0_safe_receiver_12 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_11.add_utx5q5_k$(tmp0_safe_receiver_12);
        }
      }
      tmp_27 = destination_11;
    }
    var tmp29_safe_receiver = tmp_27;
    var tmp_31;
    if (tmp29_safe_receiver == null) {
      tmp_31 = null;
    } else {
      // Inline function 'kotlin.collections.associate' call
      var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp29_safe_receiver, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_12 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_2);
      var _iterator__ex2g4s_18 = tmp29_safe_receiver.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_18.hasNext_bitz1p_k$()) {
        var element_13 = _iterator__ex2g4s_18.next_20eer_k$();
        // Inline function 'kotlin.collections.plusAssign' call
        destination_12.put_4fpzoq_k$(element_13.first_1, element_13.second_1);
      }
      tmp_31 = destination_12;
    }
    var tmp30_elvis_lhs = tmp_31;
    var weightToBasis = tmp30_elvis_lhs == null ? emptyMap() : tmp30_elvis_lhs;
    var tmp31_safe_receiver = $delayLevel;
    var tmp_32 = tmp31_safe_receiver;
    if ((tmp_32 == null ? null : new (Duration())(tmp_32)) == null)
      null;
    else {
      var tmp_33 = tmp31_safe_receiver;
      // Inline function 'kotlin.let' call
      var it_0 = (tmp_33 == null ? null : new (Duration())(tmp_33)).rawValue_1;
      yield* delay(Duration__times_impl_sfuzvp(it_0, 4), $completion);
    }
    var tmp32_safe_receiver = get_log();
    if (tmp32_safe_receiver == null)
      null;
    else {
      tmp32_safe_receiver.info_59mt0k_k$(['// Lock current sizes for appearing/expanding views.']);
    }
    var tmp33_safe_receiver = $currentShowHideQueue;
    if (tmp33_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_19 = tmp33_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_19.hasNext_bitz1p_k$()) {
        var element_14 = _iterator__ex2g4s_19.next_20eer_k$();
        $l$block_5: {
          // Inline function 'kotlin.collections.component1' call
          var on_4 = element_14.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var request_0 = element_14.get_value_j01efc_k$();
          if (!request_0.goal_1) {
            break $l$block_5;
          }
          var tmp_34 = get_native(on_4).element_1;
          var myElement_4 = tmp_34 instanceof HTMLElement ? tmp_34 : THROW_CCE();
          var tmp_35 = get_native(on_4.get_children_4cwbp4_k$().get_c1px32_k$(0)).element_1;
          var child_1 = tmp_35 instanceof HTMLElement ? tmp_35 : THROW_CCE();
          child_1.style.width = myElement_4.clientWidth.toString() + 'px';
          child_1.style.maxWidth = 'unset';
          child_1.style.height = myElement_4.clientHeight.toString() + 'px';
          child_1.style.maxHeight = 'unset';
          var tmp0_safe_receiver_13 = get_log();
          if (tmp0_safe_receiver_13 == null)
            null;
          else {
            var tmp1_safe_receiver_7 = singleOrNull(on_4.get_children_4cwbp4_k$());
            tmp0_safe_receiver_13.info_59mt0k_k$(['  View ' + (tmp1_safe_receiver_7 == null ? null : tmp1_safe_receiver_7.get_debugName_58dolx_k$()) + ' appearing locked to ' + myElement_4.clientWidth + 'px x ' + myElement_4.clientHeight + 'px']);
          }
        }
      }
    }
    var tmp34_safe_receiver = $currentWeightQueue;
    if (tmp34_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_20 = tmp34_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_20.hasNext_bitz1p_k$()) {
        var element_15 = _iterator__ex2g4s_20.next_20eer_k$();
        $l$block_6: {
          // Inline function 'kotlin.collections.component1' call
          var on_5 = element_15.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var weights_3 = element_15.get_value_j01efc_k$();
          var fromWeight_0 = weights_3.component1_7eebsc_k$();
          var toWeight_1 = weights_3.component2_7eebsb_k$();
          if (toWeight_1 < fromWeight_0) {
            break $l$block_6;
          }
          var tmp_36 = get_native(on_5).element_1;
          var myElement_5 = tmp_36 instanceof HTMLElement ? tmp_36 : THROW_CCE();
          var tmp_37 = get_native(on_5.get_children_4cwbp4_k$().get_c1px32_k$(0)).element_1;
          var child_2 = tmp_37 instanceof HTMLElement ? tmp_37 : THROW_CCE();
          child_2.style.width = myElement_5.clientWidth.toString() + 'px';
          child_2.style.maxWidth = 'unset';
          child_2.style.height = myElement_5.clientHeight.toString() + 'px';
          child_2.style.maxHeight = 'unset';
          var tmp0_safe_receiver_14 = get_log();
          if (tmp0_safe_receiver_14 == null)
            null;
          else {
            var tmp1_safe_receiver_8 = singleOrNull(on_5.get_children_4cwbp4_k$());
            tmp0_safe_receiver_14.info_59mt0k_k$(['  Weight ' + (tmp1_safe_receiver_8 == null ? null : tmp1_safe_receiver_8.get_debugName_58dolx_k$()) + ' expanding locked to ' + myElement_5.clientWidth + 'px x ' + myElement_5.clientHeight + 'px']);
          }
        }
      }
    }
    var tmp35_safe_receiver = $delayLevel;
    var tmp_38 = tmp35_safe_receiver;
    if ((tmp_38 == null ? null : new (Duration())(tmp_38)) == null)
      null;
    else {
      var tmp_39 = tmp35_safe_receiver;
      // Inline function 'kotlin.let' call
      var it_1 = (tmp_39 == null ? null : new (Duration())(tmp_39)).rawValue_1;
      yield* delay(it_1, $completion);
    }
    var tmp36_safe_receiver = get_log();
    if (tmp36_safe_receiver == null)
      null;
    else {
      tmp36_safe_receiver.info_59mt0k_k$(['// Queue the animations.']);
    }
    var tmp37_safe_receiver = $currentShowHideQueue;
    var tmp_40;
    if (tmp37_safe_receiver == null) {
      tmp_40 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_13 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(tmp37_safe_receiver.get_size_woubt6_k$());
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_21 = tmp37_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_21.hasNext_bitz1p_k$()) {
        var item_4 = _iterator__ex2g4s_21.next_20eer_k$();
        // Inline function 'kotlin.collections.component1' call
        var on_6 = item_4.get_key_18j28a_k$();
        // Inline function 'kotlin.collections.component2' call
        var request_1 = item_4.get_value_j01efc_k$();
        var goal = request_1.goal_1;
        var transition = request_1.transition_1;
        var tmp_41 = get_native(on_6).element_1;
        var myElement_6 = tmp_41 instanceof HTMLElement ? tmp_41 : THROW_CCE();
        var tmp_42 = get_native(on_6.get_children_4cwbp4_k$().get_c1px32_k$(0)).element_1;
        var child_3 = tmp_42 instanceof HTMLElement ? tmp_42 : THROW_CCE();
        var tmp_43 = get_native(ensureNotNull(on_6.get_parent_hy4reb_k$())).element_1;
        var parent = tmp_43 instanceof HTMLElement ? tmp_43 : THROW_CCE();
        var myStyle = window.getComputedStyle(myElement_6);
        var childStyle = window.getComputedStyle(child_3);
        var parentStyle_1 = window.getComputedStyle(parent);
        var tmp_44;
        var tmp0_safe_receiver_15 = on_6.get_parent_hy4reb_k$();
        var tmp_45 = tmp0_safe_receiver_15 == null ? null : tmp0_safe_receiver_15.get_underlyingNativeElement_vngz33_k$();
        if (tmp_45 instanceof Frame()) {
          tmp_44 = true;
        } else {
          var tmp1_safe_receiver_9 = on_6.get_parent_hy4reb_k$();
          var tmp_46 = tmp1_safe_receiver_9 == null ? null : tmp1_safe_receiver_9.get_underlyingNativeElement_vngz33_k$();
          tmp_44 = tmp_46 instanceof CoordinatorFrame();
        }
        var isZStack = tmp_44;
        var tmp_47;
        if (!isZStack) {
          var tmp_48;
          if (parentStyle_1.display === 'flex' && contains(parentStyle_1.flexDirection, 'row')) {
            tmp_48 = true;
          } else {
            var tmp_49;
            if (!(parentStyle_1.display === 'flex')) {
              var tmp2_elvis_lhs_1 = displayValuesPreHide.get_wei43m_k$(on_6);
              tmp_49 = contains(tmp2_elvis_lhs_1 == null ? myStyle.display : tmp2_elvis_lhs_1, 'inline');
            } else {
              tmp_49 = false;
            }
            tmp_48 = tmp_49;
          }
          tmp_47 = tmp_48;
        } else {
          tmp_47 = false;
        }
        var x = tmp_47;
        var y = !isZStack && (parentStyle_1.display === 'flex' && contains(parentStyle_1.flexDirection, 'column') || (!(parentStyle_1.display === 'flex') && parent.classList.contains('optimized')));
        // Inline function 'kotlin.takeIf' call
        var this_2 = myStyle.flexGrow;
        var tmp_50;
        var tmp_51;
        // Inline function 'kotlin.text.isNotBlank' call
        if (!isBlank(this_2)) {
          tmp_51 = !(this_2 === '0');
        } else {
          tmp_51 = false;
        }
        if (tmp_51) {
          tmp_50 = this_2;
        } else {
          tmp_50 = null;
        }
        var weighted = tmp_50;
        var usingFlexGap = parentStyle_1.display === 'flex';
        var before = {};
        var after = {};
        var full = goal ? after : before;
        var gone = goal ? before : after;
        if (x) {
          var gapX = parentStyle_1.columnGap;
          gone.marginLeft = 'calc(' + gapX + ' / -2.0)';
          gone.paddingLeft = '0px';
          gone.marginRight = 'calc(' + gapX + ' / -2.0)';
          gone.paddingRight = '0px';
          if (weighted == null) {
            var fullWidth = childStyle.width;
            gone.width = '0px';
            gone.minWidth = '0px';
            gone.maxWidth = '0px';
            full.width = fullWidth;
            full.minWidth = fullWidth;
            full.maxWidth = fullWidth;
          }
        }
        if (y) {
          if (usingFlexGap) {
            var gapY = parentStyle_1.columnGap;
            gone.marginTop = 'calc(' + gapY + ' / -2.0)';
            gone.paddingTop = '0px';
            gone.marginBottom = 'calc(' + gapY + ' / -2.0)';
            gone.paddingBottom = '0px';
          } else {
            var gap = parentStyle_1.columnGap;
            var afterLast = isLastVisibleAfterHide.contains_aljjnj_k$(on_6);
            if (afterLast) {
              full.marginBottom = '0px';
            }
            gone.marginBottom = '0px';
          }
          if (weighted == null) {
            var fullHeight = childStyle.height;
            gone.height = '0px';
            gone.minHeight = '0px';
            gone.maxHeight = '0px';
            full.height = fullHeight;
            full.minHeight = fullHeight;
            full.maxHeight = fullHeight;
          }
        }
        if (weighted == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          full.flexGrow = weighted;
          full.flexShrink = weighted;
          gone.flexGrow = '0';
          gone.flexShrink = '0';
        }
        if (transition.fade_1) {
          full.opacity = '1';
          gone.opacity = '0';
        }
        var entryTransformCss = invoke$toCssTransform(transition.entryTransform_1);
        var exitTransformCss = invoke$toCssTransform(transition.exitTransform_1);
        if (!(entryTransformCss == null) || !(exitTransformCss == null)) {
          if (goal) {
            before.transform = entryTransformCss == null ? 'none' : entryTransformCss;
            after.transform = 'none';
          } else {
            before.transform = 'none';
            after.transform = exitTransformCss == null ? 'none' : exitTransformCss;
          }
        }
        var easing = transition.easing_1;
        var easingCss = 'cubic-bezier(' + easing.x1__1 + ', ' + easing.y1__1 + ', ' + easing.x2__1 + ', ' + easing.y2__1 + ')';
        var tmp_52 = (!(before == null) ? !(before == null) : false) ? before : THROW_CCE();
        var tmp_53 = (!(after == null) ? !(after == null) : false) ? after : THROW_CCE();
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp0_elvis_lhs = pastShowHideRatios.get_wei43m_k$(on_6);
        var tmp_54;
        if (tmp0_elvis_lhs == null) {
          tmp_54 = 1.0;
        } else {
          tmp_54 = tmp0_elvis_lhs;
        }
        // Inline function 'kotlin.also' call
        var this_3 = tmp_54;
        var tmp0_safe_receiver_16 = get_log();
        if (tmp0_safe_receiver_16 == null)
          null;
        else {
          var tmp1_safe_receiver_10 = singleOrNull(on_6.get_children_4cwbp4_k$());
          tmp0_safe_receiver_16.info_59mt0k_k$(['Past for ' + (tmp1_safe_receiver_10 == null ? null : tmp1_safe_receiver_10.get_debugName_58dolx_k$()) + ' is ' + this_3]);
        }
        var tmp$ret$114 = new (OngoingAnimation())(on_6, tmp_52, tmp_53, goal, 1.0 - this_3, easingCss);
        destination_13.add_utx5q5_k$(tmp$ret$114);
      }
      tmp_40 = destination_13;
    }
    var queuedShowHideAnimations = tmp_40;
    var tmp38_safe_receiver = $currentWeightQueue;
    var tmp_55;
    if (tmp38_safe_receiver == null) {
      tmp_55 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_14 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(tmp38_safe_receiver.get_size_woubt6_k$());
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_22 = tmp38_safe_receiver.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_22.hasNext_bitz1p_k$()) {
        var item_5 = _iterator__ex2g4s_22.next_20eer_k$();
        // Inline function 'kotlin.collections.component1' call
        var on_7 = item_5.get_key_18j28a_k$();
        // Inline function 'kotlin.collections.component2' call
        var weights_4 = item_5.get_value_j01efc_k$();
        var fromWeight_1 = weights_4.component1_7eebsc_k$();
        var toWeight_2 = weights_4.component2_7eebsb_k$();
        var tmp_56;
        if (!(fromWeight_1 === 0.0)) {
          tmp_56 = '0';
        } else {
          var tmp0_elvis_lhs_0 = weightFromBasis.get_wei43m_k$(on_7);
          tmp_56 = tmp0_elvis_lhs_0 == null ? 'auto' : tmp0_elvis_lhs_0;
        }
        var tmp_57 = tmp_56;
        var tmp_58;
        if (!(toWeight_2 === 0.0)) {
          tmp_58 = '0';
        } else {
          var tmp1_elvis_lhs_0 = weightToBasis.get_wei43m_k$(on_7);
          tmp_58 = tmp1_elvis_lhs_0 == null ? 'auto' : tmp1_elvis_lhs_0;
        }
        var tmp_59 = tmp_58;
        // Inline function 'kotlin.collections.getOrElse' call
        var tmp0_elvis_lhs_1 = pastWeightRatios.get_wei43m_k$(on_7);
        var tmp_60;
        if (tmp0_elvis_lhs_1 == null) {
          tmp_60 = 1.0;
        } else {
          tmp_60 = tmp0_elvis_lhs_1;
        }
        // Inline function 'kotlin.also' call
        var this_4 = tmp_60;
        var tmp0_safe_receiver_17 = get_log();
        if (tmp0_safe_receiver_17 == null)
          null;
        else {
          var tmp1_safe_receiver_11 = singleOrNull(on_7.get_children_4cwbp4_k$());
          tmp0_safe_receiver_17.info_59mt0k_k$(['Weight past for ' + (tmp1_safe_receiver_11 == null ? null : tmp1_safe_receiver_11.get_debugName_58dolx_k$()) + ' is ' + this_4]);
        }
        var tmp$ret$129 = new (OngoingWeightAnimation())(on_7, fromWeight_1, toWeight_2, tmp_57, tmp_59, 1.0 - this_4);
        destination_14.add_utx5q5_k$(tmp$ret$129);
      }
      tmp_55 = destination_14;
    }
    var queuedWeightAnimations = tmp_55;
    var tmp39_safe_receiver = $delayLevel;
    var tmp_61 = tmp39_safe_receiver;
    if ((tmp_61 == null ? null : new (Duration())(tmp_61)) == null)
      null;
    else {
      var tmp_62 = tmp39_safe_receiver;
      // Inline function 'kotlin.let' call
      var it_2 = (tmp_62 == null ? null : new (Duration())(tmp_62)).rawValue_1;
      yield* delay(it_2, $completion);
    }
    var tmp40_safe_receiver = get_log();
    if (tmp40_safe_receiver == null)
      null;
    else {
      tmp40_safe_receiver.info_59mt0k_k$(['// Revert to what we were.']);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_23 = get_showHideAnimating().get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s_23.hasNext_bitz1p_k$()) {
      var element_16 = _iterator__ex2g4s_23.next_20eer_k$();
      element_16.get_value_j01efc_k$().continueNow_moitpb_k$();
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_24 = get_weightAnimating().get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s_24.hasNext_bitz1p_k$()) {
      var element_17 = _iterator__ex2g4s_24.next_20eer_k$();
      element_17.get_value_j01efc_k$().continueNow_moitpb_k$();
    }
    if (beforeVisibility == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_25 = beforeVisibility.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_25.hasNext_bitz1p_k$()) {
        var element_18 = _iterator__ex2g4s_25.next_20eer_k$();
        var tmp_63 = get_native(element_18.first_1).element_1;
        (tmp_63 instanceof HTMLElement ? tmp_63 : THROW_CCE()).hidden = element_18.second_1;
        var tmp0_safe_receiver_18 = get_log();
        if (tmp0_safe_receiver_18 == null)
          null;
        else {
          var tmp1_safe_receiver_12 = singleOrNull(element_18.first_1.get_children_4cwbp4_k$());
          tmp0_safe_receiver_18.info_59mt0k_k$(['View ' + (tmp1_safe_receiver_12 == null ? null : tmp1_safe_receiver_12.get_debugName_58dolx_k$()) + ' -> ' + element_18.second_1]);
        }
        var tmp_64 = element_18.first_1.get_parent_hy4reb_k$();
        var tmp2_safe_receiver_1 = tmp_64 instanceof RowOrCol() ? tmp_64 : null;
        if (tmp2_safe_receiver_1 == null)
          null;
        else {
          tmp2_safe_receiver_1.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
        }
      }
    }
    if (beforeWeightStyles == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_26 = beforeWeightStyles.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_26.hasNext_bitz1p_k$()) {
        var element_19 = _iterator__ex2g4s_26.next_20eer_k$();
        var on_8 = element_19.component1_7eebsc_k$();
        var saved = element_19.component2_7eebsb_k$();
        var tmp_65 = get_native(on_8).element_1;
        var myElement_7 = tmp_65 instanceof HTMLElement ? tmp_65 : THROW_CCE();
        myElement_7.style.flexGrow = saved.first_1;
        myElement_7.style.flexShrink = saved.second_1;
        myElement_7.style.flexBasis = saved.third_1;
        var tmp_66 = on_8.get_parent_hy4reb_k$();
        var tmp0_safe_receiver_19 = tmp_66 instanceof RowOrCol() ? tmp_66 : null;
        if (tmp0_safe_receiver_19 == null)
          null;
        else {
          tmp0_safe_receiver_19.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
        }
      }
    }
    var tmp43_safe_receiver = $delayLevel;
    var tmp_67 = tmp43_safe_receiver;
    if ((tmp_67 == null ? null : new (Duration())(tmp_67)) == null)
      null;
    else {
      var tmp_68 = tmp43_safe_receiver;
      // Inline function 'kotlin.let' call
      var it_3 = (tmp_68 == null ? null : new (Duration())(tmp_68)).rawValue_1;
      yield* delay(it_3, $completion);
    }
    var tmp44_safe_receiver = get_log();
    if (tmp44_safe_receiver == null)
      null;
    else {
      tmp44_safe_receiver.info_59mt0k_k$(['// Begin animating.']);
    }
    if (queuedShowHideAnimations == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_27 = queuedShowHideAnimations.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_27.hasNext_bitz1p_k$()) {
        var element_20 = _iterator__ex2g4s_27.next_20eer_k$();
        element_20.play_lpqhd0_k$();
      }
    }
    if (queuedWeightAnimations == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_28 = queuedWeightAnimations.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_28.hasNext_bitz1p_k$()) {
        var element_21 = _iterator__ex2g4s_28.next_20eer_k$();
        element_21.play_lpqhd0_k$();
      }
    }
    var tmp47_safe_receiver = $delayLevel;
    var tmp_69 = tmp47_safe_receiver;
    if ((tmp_69 == null ? null : new (Duration())(tmp_69)) == null)
      null;
    else {
      var tmp_70 = tmp47_safe_receiver;
      // Inline function 'kotlin.let' call
      var it_4 = (tmp_70 == null ? null : new (Duration())(tmp_70)).rawValue_1;
      yield* delay(it_4, $completion);
    }
    return Unit_instance;
  }), 1);
}
var properties_initialized_modifiers_commonHtml_js_kt_9nzjen;
function _init_properties_modifiers_commonHtml_js_kt__3eylqb() {
  if (!properties_initialized_modifiers_commonHtml_js_kt_9nzjen) {
    properties_initialized_modifiers_commonHtml_js_kt_9nzjen = true;
    showHideQueue = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
    weightChangeQueue = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
    workerScheduled = false;
    showHideAnimating = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
    weightAnimating = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
    log = null;
    combinedAnimationWorker = combinedAnimationWorker$lambda;
  }
}
//region block: exports
export {
  nativeAnimateHide as nativeAnimateHide1mu8gbca9fcry,
  nativeAnimateShow as nativeAnimateShowk0jqs20cr8om,
  nativeSetupPullToRefresh as nativeSetupPullToRefresh2bvrvj8yisrqy,
};
//endregion

//# sourceMappingURL=modifiers.commonHtml.js.mjs.map
